import { updateExpireDate, updatePremiumPlans } from "appRedux/slices/premiumSlice"

export async function handleOnPremiumPlansQueryStarted(arg: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    const { data } = await queryFulfilled
    dispatch(updatePremiumPlans(data.plans))
  } catch (error) {
    console.error("Error getting premium plans:", error)
  }
}

export async function handleOnGetActiveSubscriptionQueryStarted(arg: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    const { data } = await queryFulfilled
    dispatch(updateExpireDate(data.expireDate))
  } catch (error) {
    console.error("Error getting active subscription. Error:", error)
  }
}
